import { Component, OnInit } from '@angular/core';
import { ApiDataService } from '../../services/api.service';
import { SharedModule } from '../../shared/shared.module';
import { Router } from '@angular/router';
import { ShService } from '../../services/sh-service';
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-quick-notification',
    imports: [SharedModule],
    templateUrl: './quick-notification.component.html',
    styleUrl: './quick-notification.component.scss'
})
export class QuickNotificationComponent implements OnInit {
  currentProfile: number = -1;
  currentRole: any = '';
  currentOrg: string = '';
  quickNotification: any;
  quickNotificationLength: number = 3;
  currentLob: string = '';

  constructor(
    private _apiService: ApiDataService,
    private _service: ShService,
    private router: Router
  ){
    
  }

  ngOnInit(): void {
    this.currentLob = sessionStorage.getItem('currentLob') || '';
    this.currentRole = sessionStorage.getItem('role') || '';
    this.currentRole = parseInt(this.currentRole);
    this.currentProfile = parseInt(sessionStorage.getItem('currentProfile') || '');
    this.currentOrg = sessionStorage.getItem('org') || '';
    this.getNotification();

    this._service.localNotification$.subscribe(x => {
      if(x){
        this.quickNotification = x;
        this.quickNotification.filter((x: any) => {
          x.action = x.action && this.currentRole !== 3 && ((this.currentProfile !== 0 && x.type === 'OUT OF MARKET') || (this.currentProfile === 1 && x.type === 'NO LABEL'));
        });
      }
    });
  }

  getNotification(){
    const PAYLOAD = {
      orgId: this.currentProfile? this.currentOrg : null,
      lob: this.currentLob
    };
    this._service.notificationLoader$.next(true);
    this._apiService.getNotification(PAYLOAD).subscribe(x => {
      this.quickNotification = x;
      this.quickNotification.filter((x: any) => {
        x.action = x.action && this.currentRole !== 3 && ((this.currentProfile !== 0 && x.type === 'OUT OF MARKET') || (this.currentProfile === 1 && x.type === 'NO LABEL'));
      });

      this.quickNotification.filter((x: any) => {
        if(x.transferId){
          x.notificationDesc = x.notificationDesc.replace(x.transferId, '');
        }
        else{

        }
      });
      this._service.localNotification$.next(this.quickNotification);
      this._service.notificationLoader$.next(false);
    });
  }

  download(item: any){
    const PAYLOAD = {
      orgId: item.orgId,
      bol: item.transferId,
      type: item.type,
      destination: item.destination
    }

    this._apiService.downloadTransfer(PAYLOAD).subscribe(x => {
      
    }, (error) => {
      let blob = new Blob([error.error.text], {type: 'text/csv' });
      saveAs(blob, item.transferId+'.csv');
    });
  }

  dismiss(id: number){
    const PAYLOAD = {
      orgId: this.currentProfile? this.currentOrg : null,
      id: id,
      lob: this.currentLob
    }
    this._apiService.dismissNotification(PAYLOAD).subscribe(x => {
      this.quickNotification = this.quickNotification.filter((y: any) => y.id !== id);
      this._service.localNotification$.next(this.quickNotification);
    }, (error) => {
      
    })
  }

  goToTransfer(item: any){
    this.router.navigate(["/transfer"], {queryParams: {cartons: item.count, type: item.type, source: item.orgId, destination: item.destination}});
  }

  viewAll(){
    this.router.navigate(["/notifications"]);
  }
}
